/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

export const scanHistoryInterval = (nextInterval: Redux.ScanResultInterval) => {
  let nextIntervalNum: number

  switch (nextInterval) {
    case '7days':
      nextIntervalNum = 7
      break
    case '14days':
      nextIntervalNum = 14
      break
    case '30days':
      nextIntervalNum = 30
      break
    case 'hour':
    default:
      nextIntervalNum = 24
  }

  return nextIntervalNum
}
